import React from 'react';
import { PageHeader } from '../../components/layout/Header';
import MyDataTab from './components/MyDataTab';

const Profile: React.FC = () => {
    return (
        <div className="flex flex-col">
            <PageHeader
                title="Meus Dados"
                subtitle="Visualize e atualize suas informações pessoais e de conta."
                className="mb-0 gap-s3 md:mb-6 md:gap-3"
                titleClassName="text-lg md:text-xl"
                hideBackButton
            />
            <section aria-label="Dados do perfil" className="pt-s3 md:pt-0">
                <MyDataTab />
            </section>
        </div>
    );
};

export default Profile;
